<template>
  <div class="wrap home" v-loading="loading">
    <div class="max_width">
      <div class="nav_wrap">
        <div class="menu">
          <div class="logo">
            <div>
              <img :src="logo" />
            </div>
          </div>

          <div class="menu_wrap" v-if="showMenu">
            <el-menu
              :default-active="activeNavName"
              class="el-menu-demo"
              mode="horizontal"
              @select="handleSelect"
            >
              <el-submenu :index="itmes.title" v-for="(itmes, index) in nav">
                <template slot="title">{{ itmes.title }}</template>
                <el-menu-item
                  :index="list.name"
                  v-for="(list, inde) in itmes.list"
                  >{{ list.name }}</el-menu-item
                >
              </el-submenu>
            </el-menu>
          </div>
        </div>
        <div class="user_wrap_v2">
          <el-dropdown>
            <el-button type="primary" class="user">
              <div class="user_name">{{ userData.shiroUser.name }}</div>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <div class="shop_text">
                  <h5>Master A/C:</h5>
                  {{ merchantData.merchantNum }}
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div class="shop_text">
                  <h5>Merchant ID:</h5>
                  {{ shop.shopNum }}
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div class="shop_text">
                  <h5>Shop Name:</h5>
                  {{ shop.nameChi }}
                </div>
              </el-dropdown-item>
              <div class="button_wrap">
                <el-button size="mini" type="primary" @click="opneChangeShop">{{
                  language("home.switchShop")
                }}</el-button>
                <el-button size="mini" type="danger" @click="logout">{{
                  language("home.logout")
                }}</el-button>
              </div>
              <!-- <el-dropdown-item>
                <el-button size="mini" type="primary" @click="opneChangeShop"
                  >{{$language('home.swithShop')}}</el-button
                >
                <el-button size="mini" type="danger" @click="logout">{{
                  language("home.logout")
                }}</el-button>
              </el-dropdown-item> -->
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>

    <div class="tabs" v-if="tableTabs.length > 0">
      <el-tabs
        v-model="tableTabsValue"
        type="card"
        closable
        @tab-remove="removeTab"
        @tab-click="clickTab"
      >
        <el-tab-pane
          v-for="(item, index) in tableTabs"
          :key="item.name"
          :label="item.title"
          :name="item.name"
        >
          <span slot="label">
            <span :underline="false" class="tab" :id="index + '-id'">
              <el-tooltip
                class="item"
                effect="dark"
                :content="language('home.reload')"
                placement="bottom"
              >
                <!-- <i
                  class="el-icon-refresh rotate"
                  @dblclick="shishiClick(index)"
                  :style="'transform: rotate('+item.rotate+'deg)'"
                ></i>-->
                <i
                  class="el-icon-refresh rotate"
                  @click="resetClick(index)"
                  :style="'transform: rotate(' + item.rotate + 'deg)'"
                ></i>
              </el-tooltip>
              <span>{{ item.title }}</span>
            </span>
          </span>
          <div class="component_box" v-if="item.show">
            <component v-bind:is="item.components"></component>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <div class="welcome_tips" v-if="tableTabs.length == 0 && !loading">
      <div>
        <p><h1>歡迎使用「一本」店中店商戶管理系統</h1></p>
        <p><h2>Welcome to CMS Portal - My Book One SIS</h2></p>
      </div>
    </div>

    <template v-if="dialog">
      <el-dialog
        :close-on-click-modal="false"
        :title="language('home.shopList')"
        :visible.sync="dialog"
        width="400px"
        append-to-body
        :show-close="false"
      >
        <el-select v-model="shop.shopNum" placeholder class="select">
          <el-option
            v-for="item in shopList"
            :key="item.shopNum"
            :label="item.nameChi + '  ' + item.shopNum"
            :value="item.shopNum"
          ></el-option>
        </el-select>
        <div class="change_shop_button_wrap">
          <el-button @click="dialog = false">{{
            language("home.cancel")
          }}</el-button>
          <el-button type="primary" @click="changeShop">{{
            language("home.confirm")
          }}</el-button>
        </div>
      </el-dialog>
    </template>
  </div>
</template>
<script>
import orderQuery from "./order/orderQuery";
import productQrders from "./order/productQrders";
import shopInformation from "./shop/information";
import shopCategory from "./shop/category";
import shopCampaign from "./shop/campaign";
import shopBanners from "./shop/banners";
import productDetails from "./product/productDetails";
import SetDetails from "./product/SetDetails";
import AddEditProduct from "./product/AddEditProduct";
import productInventory from "./product/productInventory";
import promotionRules from "./promotion/promotionRules";
import companyInformation from "./setting/companyInformation";
import accountManagement from "./setting/accountManagement";
import shopList from "./setting/shopList";
import waybillManagement from "./order/waybillManagement";
import warehousingManagement from "./order/warehousingManagement";

import OrderRecord from "./report/OrderRecord";
import ProductsRecord from "./report/ProductsRecord";
import SettlementReport from "./report/SettlementReport";
import SalesRecord from "./report/SalesRecord";
import OrderRecordByProducts from "./report/OrderRecordByProducts";

import OrderProductQuery from "./Query/OrderProductQuery";

import ScrapProducts from "./product/ScrapProducts.vue";
import ScrapProductsInventory from "./product/ScrapProductsInventory.vue";
// import byOrder from "./report/byOrder";
// import orderSummary from "./report/orderSummary";
// import byProducts from "./report/byProducts";
export default {
  components: {
    orderQuery,
    productQrders,
    shopInformation,
    shopCategory,
    shopCampaign,
    shopBanners,
    productDetails,
    AddEditProduct,
    productInventory,
    promotionRules,
    companyInformation,
    accountManagement,
    // byOrder,
    // orderSummary,
    // byProducts,
    shopList,
    waybillManagement,
    warehousingManagement,
    OrderRecord,
    ProductsRecord,
    SettlementReport,
    SalesRecord,
    OrderRecordByProducts,
    OrderProductQuery,
    SetDetails,
    ScrapProducts,
    ScrapProductsInventory,
  },
  data() {
    return {
      loading: true,
      activeNavName: "Orders",
      logo: require("../file/logo2.png"),
      nav: [],

      //tab組件
      navComponents: {
        "Order Orders": "orderQuery",
        "Product Query": "productQrders",
        "Product Query": "productQrders",
        "Shop Information": "shopInformation",
        Category: "shopCategory",
        Campaign: "shopCampaign",
        Banners: "shopBanners",
        "Product Details": "productDetails",
        "Set Details": "SetDetails",
        "Damaged Products": "ScrapProducts",
        "Damaged Products Inventory": "ScrapProductsInventory",
        "Add/Edit Product": "AddEditProduct",
        "Product Inventory": "productInventory",
        "Promotion Rules": "promotionRules",
        "Company Information": "companyInformation",
        "Account Management": "accountManagement",
        "Shop List": "shopList",
        "Waybill Management": "waybillManagement",
        "Warehousing Management": "warehousingManagement",

        "Order Record": "OrderRecord",
        "Products Record": "ProductsRecord",
        "Settlement Report": "SettlementReport",
        "Sales Record": "SalesRecord",
        "Order Record By Products": "OrderRecordByProducts",

        "Order/Product Query": "OrderProductQuery",
        // "Sales Summary (By Order)": "byOrder",
        // "Order Summary": "orderSummary",
        // "Sales Summary(By Products)": "byProducts",
      },

      tableTabsValue: "0",
      tableTabs: [],
      tabIndex: 0,
      showMenu: true,
      dialog: false,
      shopList: [],
      shop: {},
      userData: {
        shiroUser: {},
      },
      merchantData: {},
    };
  },
  methods: {
    //打開頁面
    handleSelect(e, index, i) {
      console.log(e);
      let inde = null;
      for (let i = 0; i < this.tableTabs.length; i++) {
        if (this.tableTabs[i].title == e) {
          inde = this.tableTabs[i].name;
        }
      }

      if (inde != null) {
        this.tableTabsValue = inde + "";
      } else {
        let newTabName = ++this.tabIndex + "";
        this.tableTabs.push({
          title: e,
          name: newTabName,
          components: this.navComponents[e],
          show: true,
          rotate: 0,
        });
        this.tableTabsValue = newTabName;
      }
    },

    //刪除頁面
    removeTab(targetName) {
      let tabs = this.tableTabs;
      let activeName = this.tableTabsValue;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }
      this.tableTabsValue = activeName;
      this.tableTabs = tabs.filter((tab) => tab.name !== targetName);
      if (this.tableTabs.length == 0) {
        this.activeNavName = null;
        this.changeMenu();
      }
    },

    //重置頁面
    resetClick(e) {
      this.tableTabs[e].show = false;
      this.tableTabs[e].rotate += 300;
      this.$nextTick(function () {
        this.tableTabs[e].show = true;
      });
    },

    clickTab(e) {
      this.activeNavName = e.label;
    },
    opneChangeShop() {
      this.dialog = true;
    },

    changeShop() {
      this.dialog = false;
      this.tableTabs = [];
      this.activeNavName = null;
      this.changeMenu();
      // this.$message.success(this.language("home.changeSuccess"));

      this.$notify({
        showClose: false,
        title: this.language("home.changeSuccess"),
        duration: 2000,
      });
      for (let i = 0; i < this.shopList.length; i++) {
        if (this.shopList[i].shopNum == this.shop.shopNum) {
          this.shop = { ...this.shopList[i] };
          this.storage.setStorage("shop", this.shopList[i]);
          this.$bus.$emit("changeUser", this.shopList[i]);
        }
      }
    },
    changeMenu() {
      this.showMenu = false;
      this.$nextTick(() => {
        this.showMenu = true;
      });
    },

    //獲取菜單權限並且保存
    setNavicat() {
      this.ccRequest
        .do("admin/merchant/user/getMenuList", {})
        .then((res) => {
          this.SetMenuList(res)
            .then((e) => {
              this.getNavicat(e);
            })
            .catch((err) => {
              console.log(err);
            });
          this.getShopList();
        })
        .catch((err) => {
          console.log(err);
          this.$message.error(err.response.data.message);
          this.$router.push({ path: "/login" });
        });
    },
    //菜單構建
    getNavicat(menuList) {
      let nav = [];
      if (menuList["SIS-Query-Query/Product-Query/Product"]) {
        nav.push({
          title: "Query",
          list: [
            {
              name: "Order/Product Query",
            },
          ],
        });
      }

      if (menuList["SIS-Orders-View-View"]) {
        nav.push({
          title: "Orders",
          list: [
            {
              name: "Waybill Management",
            },
            {
              name: "Warehousing Management",
            },
          ],
        });
      }

      if (
        menuList["SIS-Products-Inventory-View"] ||
        menuList["SIS-Products-ProductInfo-View"] ||
        menuList["SIS-Product-Package-Info-View"] ||
        menuList["SIS-Product-Discount-Info-View"] ||
        menuList["SIS-Product-Discount-Inventory-View"]
      ) {
        let products = {
          title: "Products",
          list: [],
        };
        if (menuList["SIS-Products-ProductInfo-View"]) {
          products.list.push({
            name: "Product Details",
          });
        }

        if (
          menuList["SIS-Products-ProductInfo-Add"] ||
          menuList["SIS-Products-ProductInfo-Edit"]
        ) {
          products.list.push({
            name: "Add/Edit Product",
          });
        }

        if (menuList["SIS-Products-Inventory-View"]) {
          products.list.push({
            name: "Product Inventory",
          });
        }

        if (menuList["SIS-Product-Package-Info-View"]) {
          products.list.push({
            name: "Set Details",
          });
        }

        //報廢書
        if (menuList["SIS-Product-Discount-Info-View"]) {
          products.list.push({
            name: "Damaged Products",
          });
        }

        if (menuList["SIS-Product-Discount-Inventory-View"]) {
          products.list.push({
            name: "Damaged Products Inventory",
          });
        }

        if (products.list.length > 0) {
          nav.push(products);
        }
      }

      if (menuList["SIS-Promotions-Rules-View"]) {
        nav.push({
          title: "Promotions",
          list: [
            {
              name: "Promotion Rules",
            },
          ],
        });
      }

      let shopDisplay = {
        title: "Shop Display",
        list: [
          // {
          //   name: "Shop Information",
          // },
          // {
          //   name: "Category",
          // },
          // {
          //   name: "Campaign",
          // },
          // {
          //   name: "Banners",
          // },
        ],
      };
      if (
        menuList["SIS-ShopDisplay-View/Edit Info.-Shop Info."] ||
        menuList["SIS-ShopDisplay-View/EditInfo.-CustomerServices"] ||
        menuList["SIS-ShopDisplay-View/EditInfo.-ShopDesc"] ||
        menuList["SIS-ShopDisplay-View/EditInfo.-T&C"] ||
        menuList["SIS-ShopDisplay-View/Edit Info.-BussinessDays"]
      ) {
        shopDisplay.list.push({ name: "Shop Information" });
      }
      if (menuList["SIS-ShopDisplay-Category-View"]) {
        shopDisplay.list.push({ name: "Category" });
      }
      if (menuList["SIS-ShopDisplay-Campaign-View"]) {
        shopDisplay.list.push({ name: "Campaign" });
      }
      if (menuList["SIS-ShopDisplay-Banner-View"]) {
        shopDisplay.list.push({ name: "Banners" });
      }
      if (shopDisplay.list.length > 0) {
        nav.push(shopDisplay);
      }

      let setting = {
        title: "Setting",
        list: [],
      };
      if (menuList["SIS-Setting-CompanyInfo-CompanyInfo"]) {
        setting.list.push({
          name: "Company Information",
        });
      }
      if (menuList["SIS-Setting-A/CSetting-A/CSetting"]) {
        setting.list.push({
          name: "Account Management",
        });
      }
      if (menuList["SIS-Setting-ShopList-View"]) {
        setting.list.push({
          name: "Shop List",
        });
      }
      if (setting.list.length > 0) {
        nav.push(setting);
      }

      let report = {
        title: "Report",
        list: [],
      };
      if (menuList["SIS-Report-View/Download-OrderRecord"]) {
        report.list.push({
          name: "Order Record",
        });
      }
      if (menuList["SIS-Report-View/Download-ProductsRecord"]) {
        report.list.push({
          name: "Products Record",
        });
      }

      if (menuList["SIS-Report-View/Download-SettlementReport"]) {
        report.list.push({
          name: "Settlement Report",
        });
      }
      if (menuList["SIS-Report-View/Download-SalesRecord"]) {
        report.list.push({
          name: "Sales Record",
        });
      }
      if (menuList["SIS-Report-View/Download-OrderRecordByProducts"]) {
        report.list.push({
          name: "Order Record By Products",
        });
      }
      if (report.list.length > 0) {
        nav.push(report);
      }

      this.nav = nav;
    },
    getShopList(merchantNum) {
      //1詳細信息 0不詳細
      this.ccRequest
        .do("admin/merchant/shop/user/rel/queryShopList", {
          allShow: 0,
          merchantNum: merchantNum,
        })
        .then((res) => {
          this.loading = false;
          this.shopList = res.rows;
          this.shop = { ...res.rows[0] };
          // if (res.rows.length == 1) {
          //   this.storage.setStorage("shop", res.rows[0]);
          // } else {
          this.storage.setStorage("shop", res.rows[0]);
          this.dialog = true;
          // }
          this.$bus.$emit("changeUser", res.rows[0]);

          this.getUserData(res.rows[0].shopNum, res.rows[0].merchantNum);
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err.response.data.message);
          setTimeout(() => {
            this.logout();
          }, 1000);
        });
    },
    getUserData(shopNum, merchantNum) {
      //賬號信息
      // this.ccRequest
      //   .do("admin/merchant/shop/user/rel/validate", { shopNum: shopNum })
      //   .then((res) => {
      //     this.userData = res;
      //   })
      //   .catch((err) => {});
      //商戶信息
      this.ccRequest
        .do("admin/merchant/getMerchantInfo", {
          merchantNum: merchantNum,
        })
        .then((res) => {
          this.merchantData = res;
        })
        .catch((err) => {});
    },
    getUserName() {
      if (localStorage.getItem(process.env.VUE_APP_shiroUserName)) {
        try {
          this.userData = {
            shiroUser: {
              name: localStorage.getItem(process.env.VUE_APP_shiroUserName),
            },
          };
        } catch (error) {
          this.$message.error("數據非法，請重新登錄");
          this.$router.push({ path: "/login" });
        }
      }
    },
    logout() {
      this.ccRequest
        .do("admin/merchant/user/logout", {})
        .then((res) => {
          this.storage.delStorage("shop");
          this.storage.delStorage(process.env.VUE_APP_menuList);
          this.storage.delStorage(process.env.VUE_APP_shiroUserName);
          this.$router.push({ path: "/login" });
        })
        .catch((err) => {
          console.log(err);
          this.$message.error(err.response.data.message);
        });
    },
  },
  mounted() {
    this.getUserName();
    this.setNavicat();
    this.getShopList();
  },
};
</script>
<style lang="scss">
.el-menu.el-menu--horizontal {
  border: none;
}

.el-submenu__title {
  font-size: 18px !important;
  font-weight: 500;
}
.el-menu-item {
  font-size: 16px !important;
}
.el-dropdown-menu__item {
  cursor: default !important;
}
.el-tabs__header {
  // position: fixed;
  // top: 90px;
  // z-index: 2;
  // background: #fff;
}
.home .user span {
  display: flex;
}
</style>
<style lang="scss" scoped>
.home {
  min-height: 100vh;
}
.max_width {
  width: 100%;
  // position: fixed;
  // z-index: 2;
  // background: #fff;
}
.nav_wrap {
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  max-width: 1920px;
  margin: 0 auto;
}
img {
  width: 150px;
}
.menu {
  display: flex;
}
.menu_wrap {
  display: flex;
  align-items: center;
}
.logo {
  padding-top: 20px;
  color: #797373;
  font-size: $minTitle;
  font-weight: 600;
  display: flex;
  align-items: center;
  margin-right: 45px;
}

.user_wrap_v2 {
  display: flex;
  align-items: center;
}

.component_box {
  // height: calc(100vh - 184px);
  // overflow-y: auto;
  padding: 0 20px;
  box-sizing: border-box;
}
.el-icon-refresh:hover {
  color: #797373;
}
.rotate {
  margin-right: 10px;
  transform: rotate(0deg);
  transition: 2s;
}
.tab {
  font-size: 16px;
}
.tabs {
  max-width: 1920px;
  margin: 0 auto;
}
.select {
  width: 100%;
}
.change_shop_button_wrap {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.button_wrap {
  padding: 20px 0;
  display: flex;
  justify-content: center;
}

.user_name {
  max-width: 119px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.shop_text {
  display: flex;
  align-items: center;
  h5 {
    margin-right: 5px;
    font-size: 14px;
  }
}
.welcome_tips {
  position: absolute;
  height: calc(100% - 90px);
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  h2,
  h1 {
    text-align: center;
    color: #909399;
  }
  h1 {
    font-size: 30px;
  }
  h2 {
    font-size: 24px;
  }
}
</style>